<template>
    <span>
        <router-link :to="{name:'ClocksHome'}" tag="a">
            <i class="fas fa-arrow-left"></i>
        </router-link>
        <span class="title-separator">|</span>
        <span>
            <span v-if="isLoadingClock">...</span>
            <span v-else-if="currentClock !== null">
                <!--{{ Translations.sections.clocks.sectionTitle }}
                <span class="title-separator">-</span>-->
                <span v-if="isLoadingClock">Loading clock ...</span>
                <span v-else>{{ currentClock.name }}</span>
            </span>
        </span>
    </span>
</template>

<script>
    import Vue from 'vue';
    import { mapState, mapActions } from 'vuex'
    import store from '@/store/index.js'
    import Bootstrap from 'bootstrap-vue'
    import Translations from '@/store/translations';

    Vue.use(Bootstrap);

    export default {
        name: "ClockHeader",
        store,
        components: {
        },
        computed: {
            Translations: () => Translations,
            ...mapState({
                currentClock: state => state.currentClock,
                isLoadingClock: state => state.loadingStates.isLoadingBox
            }),
        },
        data() {
            return {}
        }
    }

</script>

<style scoped>
</style>